
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs-channel",
      function () {
        return require("private-next-pages/jobs-channel/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs-channel"])
      });
    }
  